import { render } from "./FooterEntry.vue?vue&type=template&id=59b58417&scoped=true"
import script from "./FooterEntry.vue?vue&type=script&lang=js"
export * from "./FooterEntry.vue?vue&type=script&lang=js"

import "./FooterEntry.vue?vue&type=style&index=0&id=59b58417&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b58417"]])

export default __exports__